import Component from '../../lib/component'
import { RootComponent } from '../../main'
import Tabbable from 'tabbable'

export default class StickyBarComponent extends Component {
    static selector () {
        return '.sticky-bar'
    }

    constructor (opts) {
        super(opts)

        if (this.getBrowser('name') === 'ie') {
            if (this.props.stickyScrollListenerSelector)
                this.el.style.display = 'none'

            this.props.stickyDisabled = 'true'
            return
        }

        this.init = true
        this.width = this.el.clientWidth

        this.render()
        this.listen()
    }

    listen () {
        RootComponent.Scroller.state
            .on('update', this.render.bind(this))

        RootComponent.Scroller
            .on('scroll:debounced', () =>
                this.render({ type: 'debounced' }))

        this.on('resize', () => {
            if (!this.getFeature('touch'))
                return this.render()

            if (this.width === this.el.clientWidth)
                return

            this.render()
            this.width = this.el.clientWidth
        })
    }

    isStickyDisabled () {
        return this.props.stickyDisabled === 'true'
    }

    isUnstickParentBoundsBottom () {
        return this.props.unstickParentBoundsBottom === 'true'
    }

    getScrollListenerEl () {
        return this.props.stickyScrollListenerSelector
            ? document.querySelector(this.props.stickyScrollListenerSelector)
            : null
    }

    getScrollYOffset () {
        if (this.isStickyDisabled())
            return 0

        const stickyBars = Array.from(document.querySelectorAll('.sticky-bar'))
        const stickyBarIdx = stickyBars.indexOf(this.el)
        const stickyBarsOffset = stickyBarIdx > 0
            ? stickyBars.slice(0, stickyBarIdx)
                .filter(el =>
                    el.getAttribute('data-unstick-parent-bounds-bottom')
                        !== 'true')
                .map(el => el.offsetHeight)
                .reduce((int, val) => int + val)
            : 0

        const getComputedStyleInt = (el, prop) => Number(
            (window.getComputedStyle(el)[prop] || '0')
                .replace(/[a-z]/ig, ''))

        return stickyBarsOffset
            + Number(this.props.scrollyOffset || '0')
            + getComputedStyleInt(document.documentElement, 'paddingTop')
            + getComputedStyleInt(document.documentElement, 'marginTop')
            + getComputedStyleInt(document.body, 'paddingTop')
            + getComputedStyleInt(document.body, 'marginTop')
    }

    getScrollDebeounceDirection () {
        let debounceDirection = this.props.stickyDebounceScrollDirection

        if (!debounceDirection)
            return null

        debounceDirection = debounceDirection.match(/(up|down)/)
            ? debounceDirection
            : 'all'

        if (this.props.stickyDebounceScrollDirection !== debounceDirection)
            this.props.stickyDebounceScrollDirection = debounceDirection

        return debounceDirection
    }

    renderStickyBarClone () {
        if (this.clone)
            return

        this.clone = this.el.cloneNode(true)
        this.clone.id = `${this.el.id || 'sticky-bar'}-${this.generateGUID()}`

        this.clone.classList.remove('sticky-bar')
        this.clone.classList.add('sticky-bar-clone')

        this.clone.removeAttribute('data-rendered')
        this.clone.removeAttribute('data-breakpoints')
        this.clone.removeAttribute('data-sticky-disabled')
        this.clone.removeAttribute('data-sticky-on-init')
        this.clone.removeAttribute('data-sticky-transition-in')
        this.clone.removeAttribute('data-sticky-transition-out')
        this.clone.removeAttribute('data-sticky-debounce-scroll-direction')
        this.clone.removeAttribute('data-unstick-parent-bounds-bottom')

        Array.from(this.clone.querySelectorAll('[data-rendered]'))
            .forEach(el => {
                const cloneEl = el.cloneNode(true)

                cloneEl.removeAttribute('data-rendered')

                if (cloneEl.getAttribute('data-expand')) {
                    cloneEl.removeAttribute('aria-expanded')
                    cloneEl.removeAttribute('aria-controls')
                }

                el.parentElement
                    .insertBefore(cloneEl, el)

                el.remove()
            })

        Array.from(this.clone.querySelectorAll('[id]'))
            .forEach(el => {
                const id = el.id
                el.id = `${id}-sticky-bar-clone`

                const selectorExp = new RegExp(`(["']#*)${id}("|')`, 'g')

                this.clone.innerHTML = this.clone.innerHTML
                    .replace(selectorExp, `$1${el.id}$2`)
            })

        this.props.stickyScrollListenerSelector = `#${this.clone.id}`

        if (!('stickBoundsTop' in this.props))
            this.props.stickBoundsTop
                = !this.props.stickyDebounceScrollDirection

        this.el.parentElement
            .insertBefore(this.clone, this.el)
    }

    setStickyState (isSticky, isDebounced, isUnsticky) {
        if ((isSticky && this.props.sticky === 'true')
                || (!isSticky && this.props.sticky === 'false'))
            return

        if (this.init)
            this.props.stickyOnInit = isSticky

        if (!isSticky
                && this.props.stickyDebounced === 'true')
            this.props.stickyDebounced = false

        if (isSticky
                && isDebounced
                && this.props.stickyDebounced !== 'true')
            this.props.stickyDebounced = true

        if (!isSticky
                && isUnsticky
                && this.props.unsticky !== 'true')
            this.props.unsticky = isUnsticky

        const isUnstickParentBoundsBottom = this.isUnstickParentBoundsBottom()
            && this.el.parentElement

        if (!isSticky
                && !isUnsticky
                && isUnstickParentBoundsBottom
                && this.props.unsticky === 'true')
            this.props.sticky = false

        const isCloneStickTop = this.clone
            && this.props.stickBoundsTop === 'true'

        if (isCloneStickTop
                && !isUnstickParentBoundsBottom)
            this.clone.style.visibility = isSticky
                ? 'hidden'
                : ''

        if (isCloneStickTop
                && isUnstickParentBoundsBottom) {
            if (this.el.style.visibility !== 'visible')
                this.el.style.visibility = 'visible'

            if (this.clone.style.visibility !== 'visible')
                this.clone.style.visibility = 'visible'

            this.el.setAttribute('aria-hidden', !isSticky)
            this.clone.setAttribute('aria-hidden', isSticky)

            const els = Tabbable(this.el, { includeContainer: true })
            const cloneEls = Tabbable(this.clone, { includeContainer: true })

            if (this.init) {
                els.forEach(el => !el.getAttribute('data-tabindex-restore')
                    ? el.setAttribute('data-tabindex-restore',
                        el.getAttribute('tabindex') || true)
                    : null)

                cloneEls.forEach(el => !el.getAttribute('data-tabindex-restore')
                    ? el.setAttribute('data-tabindex-restore',
                        el.getAttribute('tabindex') || true)
                    : null)
            }

            els.filter(el => el.getAttribute('data-tabindex-restore'))
                .forEach(el => {
                    if (!isSticky)
                        return el.setAttribute('tabindex', -1)

                    const tabindex = el.getAttribute('data-tabindex-restore')

                    if (isSticky && tabindex !== 'true')
                        el.setAttribute('tabindex', tabindex)

                    if (isSticky && tabindex === 'true')
                        el.removeAttribute('tabindex')
                })

            cloneEls.filter(el => el.getAttribute('data-tabindex-restore'))
                .forEach(el => {
                    if (isSticky)
                        return el.setAttribute('tabindex', -1)

                    const tabindex = el.getAttribute('data-tabindex-restore')

                    if (!isSticky && tabindex !== 'true')
                        el.setAttribute('tabindex', tabindex)

                    if (!isSticky && tabindex === 'true')
                        el.removeAttribute('tabindex')
                })
        }

        this.props.sticky = isSticky
    }

    render (e) {
        if (this.isUnstickParentBoundsBottom()
                && (!('stickyDebounceScrollDirection' in this.props))) {
            if (!('stickBoundsTop' in this.props))
                this.props.stickBoundsTop = true

            if (!('stickyDebounceScrollDirection' in this.props))
                this.props.stickyDebounceScrollDirection = 'up'
        }

        if (!('stickyScrollListenerSelector' in this.props))
            this.renderStickyBarClone()

        const scrollDebounceDir = this.getScrollDebeounceDirection()

        const scrollDir = RootComponent.Scroller.state
            .get('directionY')

        const isEventDebounced = (e || {}).type === 'debounced'

        const unstickParentBounds = this.isUnstickParentBoundsBottom()
                && this.el.parentElement
            ? this.el.parentElement.getBoundingClientRect()
            : null

        if (unstickParentBounds
                && unstickParentBounds.bottom < -1
                && this.props.unsticky !== 'true')
            this.props.unsticky = true

        if (unstickParentBounds
                && unstickParentBounds.top > window.innerHeight
                && this.props.unsticky === 'true')
            this.props.unsticky = false

        if (scrollDebounceDir
                && !isEventDebounced
                && (scrollDebounceDir === scrollDir
                    || scrollDebounceDir === 'all')
                && this.props.sticky !== 'true')
            return

        const scrollEl = this.getScrollListenerEl()

        if (!scrollEl)
            return

        const stickyBarTop = this.getScrollYOffset()
                && !this.isStickyDisabled()
            ? `${this.getScrollYOffset()}px`
            : null

        if (!stickyBarTop
                && this.el.style.top)
            this.el.style.top = ''

        if (stickyBarTop
                && this.el.style.top !== stickyBarTop)
            this.el.style.top = stickyBarTop

        if (!this.isStickyDisabled()
                && this.clone
                && this.clone.getAttribute('data-sticky-bar-clone-disabled'))
            this.clone.removeAttribute('data-sticky-bar-clone-disabled')

        if (this.isStickyDisabled()
                && this.clone
                && !this.clone.getAttribute('data-sticky-bar-clone-disabled'))
            this.clone.setAttribute('data-sticky-bar-clone-disabled', true)

        if (this.isStickyDisabled()) {
            if (this.props.sticky !== 'false')
                this.props.sticky = false

            this.init = false

            return
        }

        const isScrollDebounced = scrollDebounceDir
            && ((isEventDebounced
                && (scrollDir === scrollDebounceDir
                        || scrollDebounceDir === 'all'))
                || (!isEventDebounced
                    && scrollDir !== scrollDebounceDir
                    && scrollDebounceDir !== 'all'))

        const isUnsticky = unstickParentBounds
            && this.getScrollYOffset() + this.el.clientHeight
                >= Math.floor(unstickParentBounds.bottom)

        const scrollElBounds = scrollEl.getBoundingClientRect()

        const scrollY = this.props.stickBoundsTop === 'true'
            ? scrollElBounds.top
            : scrollElBounds.bottom - 1

        if (this.props.sticky === 'false'
                && scrollY > window.innerHeight)
            return

        const isSticky = this.getScrollYOffset() >= Math.ceil(scrollY)
            && !isUnsticky

        if ((!isSticky
                    && this.props.sticky !== 'false')
                || (isSticky
                    && this.props.sticky !== 'true'
                    && (!scrollDebounceDir
                        || isScrollDebounced)))
            this.setStickyState(isSticky,
                isSticky
                    && isEventDebounced
                    && isScrollDebounced,
                isUnsticky)

        this.init = false
    }
}
